function clearEmptyValues(obj) {
  Object.keys(obj).map(value => {
    if (typeof obj[value] === 'string' && obj[value].length === 0) {
      obj[value] = null;
    }
  });
}
export { clearEmptyValues };
